import { Schema } from 'effect'

export const Environment = Schema.Literals([
  'test',
  'development',
  'production',
])
export type Environment = typeof Environment.Type
export const DefaultEnvironment = 'development' satisfies Environment
